"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numberInputReducer = numberInputReducer;
var _numberInputAction = require("./numberInputAction.types");
var _utils = require("./utils");
function getClampedValues(rawValue, context) {
    var min = context.min, max = context.max, step = context.step;
    var clampedValue = rawValue === null ? null : (0, _utils.clampStepwise)(rawValue, min, max, step);
    var newInputValue = clampedValue === null ? '' : String(clampedValue);
    return {
        value: clampedValue,
        inputValue: newInputValue
    };
}
function stepValue(state, context, direction, multiplier) {
    var value = state.value;
    var _context_step = context.step, step = _context_step === void 0 ? 1 : _context_step, min = context.min, max = context.max;
    if ((0, _utils.isNumber)(value)) {
        return ({
            up: value + (step !== null && step !== void 0 ? step : 1) * multiplier,
            down: value - (step !== null && step !== void 0 ? step : 1) * multiplier
        })[direction];
    }
    return ({
        up: min !== null && min !== void 0 ? min : 1,
        down: max !== null && max !== void 0 ? max : -1
    })[direction];
}
function handleClamp(state, context, inputValue) {
    var getInputValueAsString = context.getInputValueAsString;
    var numberValueAsString = getInputValueAsString(inputValue);
    var intermediateValue = numberValueAsString === '' || numberValueAsString === '-' ? null : parseInt(numberValueAsString, 10);
    var clampedValues = getClampedValues(intermediateValue, context);
    return _object_spread({}, state, clampedValues);
}
function handleInputChange(state, context, inputValue) {
    var getInputValueAsString = context.getInputValueAsString;
    var numberValueAsString = getInputValueAsString(inputValue);
    if (numberValueAsString.match(/^-?\d+?$/) || numberValueAsString === '' || numberValueAsString === '-') {
        return _object_spread_props(_object_spread({}, state), {
            inputValue: numberValueAsString
        });
    }
    return state;
}
// use this for ArrowUp, ArrowDown, button clicks
// use this with applyMultiplier: true for PageUp, PageDown, button shift-clicks
function handleStep(state, context, applyMultiplier, direction) {
    var multiplier = applyMultiplier ? context.shiftMultiplier : 1;
    var newValue = stepValue(state, context, direction, multiplier);
    var clampedValues = getClampedValues(newValue, context);
    return _object_spread({}, state, clampedValues);
}
function handleToMinOrMax(state, context, to) {
    var newValue = context[to];
    if (!(0, _utils.isNumber)(newValue)) {
        return state;
    }
    return _object_spread_props(_object_spread({}, state), {
        value: newValue,
        inputValue: String(newValue)
    });
}
function numberInputReducer(state, action) {
    var type = action.type, context = action.context;
    switch(type){
        case _numberInputAction.NumberInputActionTypes.clamp:
            return handleClamp(state, context, action.inputValue);
        case _numberInputAction.NumberInputActionTypes.inputChange:
            return handleInputChange(state, context, action.inputValue);
        case _numberInputAction.NumberInputActionTypes.increment:
            return handleStep(state, context, action.applyMultiplier, 'up');
        case _numberInputAction.NumberInputActionTypes.decrement:
            return handleStep(state, context, action.applyMultiplier, 'down');
        case _numberInputAction.NumberInputActionTypes.incrementToMax:
            return handleToMinOrMax(state, context, 'max');
        case _numberInputAction.NumberInputActionTypes.decrementToMin:
            return handleToMinOrMax(state, context, 'min');
        case _numberInputAction.NumberInputActionTypes.resetInputValue:
            return _object_spread_props(_object_spread({}, state), {
                inputValue: String(state.value)
            });
        default:
            return state;
    }
}
